import React from 'react';
import { Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';

const MenuItem = ({ location, title, icon, advanced, tenantPath }) => (
  <NavLink
    to={{ pathname: `${tenantPath}${location}` }}
    className={`side-navigation-menu-item ${location.slice(1)}-link`}
  >
    <Tooltip placement="right" title={title}>
      {React.isValidElement(icon) &&
        React.cloneElement(icon, { style: { fontSize: 20, marginBottom: 5 } })}
      {advanced && '*'}
    </Tooltip>
  </NavLink>
);

export default MenuItem;
